import './App.css';
import General from './js/General';

function App() {
  return (
    <div className="App">
      <General/>
    </div>
  );
}

export default App;
